<template>
  <SkeletonLoader>
    <div class="admin-skeleton">
      <!-- Header: "Today" title centered + toolbar -->
      <div class="admin-skeleton__header">
        <div class="admin-skeleton__title">
          <div class="sk-line sk-line--xl" style="width: 120px; margin: 0 auto"></div>
        </div>
        <div class="admin-skeleton__toolbar">
          <div class="sk-rect" style="width: 72px; height: 32px; border-radius: 4px"></div>
          <div class="sk-rect" style="width: 72px; height: 32px; border-radius: 4px"></div>
        </div>
      </div>

      <!-- My Tasks: full-width widget -->
      <div class="admin-skeleton__full-widget">
        <div class="admin-skeleton__widget">
          <div class="sk-line sk-line--title" style="width: 35%"></div>
          <div v-for="row in myTasksRows" :key="'tasks-' + row.id" class="sk-row">
            <div class="sk-rect" style="width: 18px; height: 18px; border-radius: 3px; flex-shrink: 0"></div>
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>
      </div>

      <!-- 2-column grid: Overdue Recall + Unscheduled Treatment -->
      <div class="admin-skeleton__grid">
        <div class="admin-skeleton__widget">
          <div class="admin-skeleton__widget-header">
            <div class="sk-line sk-line--title" style="width: 55%"></div>
            <div class="sk-line sk-line--sm" style="width: 30%"></div>
          </div>
          <div class="sk-rect" style="width: 100%; height: 6px; border-radius: 3px; margin-bottom: 12px"></div>
          <div v-for="row in overdueRecallRows" :key="'recall-' + row.id" class="sk-row">
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>

        <div class="admin-skeleton__widget">
          <div class="admin-skeleton__widget-header">
            <div class="sk-line sk-line--title" style="width: 65%"></div>
            <div class="sk-line sk-line--sm" style="width: 28%"></div>
          </div>
          <div class="sk-rect" style="width: 100%; height: 6px; border-radius: 3px; margin-bottom: 12px"></div>
          <div v-for="row in unscheduledRows" :key="'unsched-' + row.id" class="sk-row">
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>
      </div>

      <!-- 2-column grid: Broken Appointments + Outstanding Claims -->
      <div class="admin-skeleton__grid">
        <div class="admin-skeleton__widget">
          <div class="admin-skeleton__widget-header">
            <div class="sk-line sk-line--title" style="width: 60%"></div>
            <div class="sk-line sk-line--sm" style="width: 32%"></div>
          </div>
          <div v-for="row in brokenApptRows" :key="'broken-' + row.id" class="sk-row">
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>

        <div class="admin-skeleton__widget">
          <div class="admin-skeleton__widget-header">
            <div class="sk-line sk-line--title" style="width: 58%"></div>
            <div class="sk-line sk-line--sm" style="width: 26%"></div>
          </div>
          <div v-for="row in outstandingClaimsRows" :key="'claims-' + row.id" class="sk-row">
            <div class="sk-col">
              <div class="sk-line" :style="{ width: row.width }"></div>
            </div>
            <div class="sk-line sk-line--sm" :style="{ width: row.trailing }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'AdminPageSkeleton',
  components: { SkeletonLoader },
  data () {
    return {
      myTasksRows: [
        { id: 1, width: '70%', trailing: '60px' },
        { id: 2, width: '55%', trailing: '48px' },
        { id: 3, width: '80%', trailing: '52px' },
        { id: 4, width: '62%', trailing: '44px' }
      ],
      overdueRecallRows: [
        { id: 1, width: '75%', trailing: '48px' },
        { id: 2, width: '60%', trailing: '36px' },
        { id: 3, width: '85%', trailing: '52px' },
        { id: 4, width: '50%', trailing: '40px' }
      ],
      unscheduledRows: [
        { id: 1, width: '68%', trailing: '44px' },
        { id: 2, width: '78%', trailing: '38px' },
        { id: 3, width: '55%', trailing: '50px' },
        { id: 4, width: '72%', trailing: '42px' }
      ],
      brokenApptRows: [
        { id: 1, width: '72%', trailing: '46px' },
        { id: 2, width: '58%', trailing: '34px' },
        { id: 3, width: '82%', trailing: '48px' },
        { id: 4, width: '65%', trailing: '40px' }
      ],
      outstandingClaimsRows: [
        { id: 1, width: '66%', trailing: '50px' },
        { id: 2, width: '80%', trailing: '36px' },
        { id: 3, width: '52%', trailing: '44px' },
        { id: 4, width: '74%', trailing: '42px' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-skeleton {
  padding: 24px;

  &__header {
    margin-bottom: 20px;
  }

  &__title {
    text-align: center;
    margin-bottom: 12px;
  }

  &__toolbar {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
  }

  &__full-widget {
    margin-bottom: 20px;
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  &__widget {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 20px;
  }

  &__widget-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }
}
</style>
